import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=3e15b85e&scoped=true"
import script from "./VButton.vue?vue&type=script&lang=js"
export * from "./VButton.vue?vue&type=script&lang=js"
import style0 from "./VButton.vue?vue&type=style&index=0&id=3e15b85e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e15b85e",
  null
  
)

export default component.exports